/** default locale */
export const DEFAULT_LOCALE = "en-US";
